<template>
	<iframe
		:src="printPageUrl"
		style="visibility: hidden; position: absolute; top: -9999px; left: -9999px;"
		height="0"
		width="0"
		ref="iframe"
		v-if="printQueueMultipleRowKey"
		:sandbox="sandboxVals"
	/>
</template>

<script>
import messageHandlerMixin from '@/mixins/message-handler-mixin';
import { mapGetters, mapActions } from 'vuex';
import buildRoute from '@/composables/build-route';
import getCompanyId from '@/composables/get-companyid';

export default {
	name: 'PrintQueueMultipleIframe',
	mixins: [messageHandlerMixin],
	computed: {
		...mapGetters('printing', [
			'printQueueMultipleRowKey',
			'printQueueMultipleIframeActive'
		]),
		printPageUrl() {
			const page = process.env.VUE_APP_ACCESSWEB_PRINT_PAGE;
			let url;
			const companyId = getCompanyId(this.$route);

			url = buildRoute(page, {
				query: { rowKey: this.printQueueMultipleRowKey, cid: companyId }
			});

			return url;
		},
		sandboxVals() {
			const sandbox = [
				'allow-forms',
				'allow-modals',
				'allow-popups',
				'allow-scripts',
				'allow-top-navigation',
				'allow-same-origin',
				'allow-top-navigation'
			];
			let vals = '';

			if (sandbox) {
				vals = sandbox.join(' ');
			}

			return vals;
		}
	},
	methods: {
		...mapActions('printing', ['printQueueMultipleLoadedAction']),
		onMessage(message) {
			//gets called from message-handler-mixin
			if (message && message.printQueueMultiple) {
				this.printQueueMultipleLoadedAction({
					loaded: true,
					iframeRef: this.$refs.iframe
				});

				this.$refs.iframe.contentWindow.onPrint();
			}
		}
	}
};
</script>

<style lang="scss" scoped></style>
